import * as React from "react"
import { SFProIcon, SFProIconProps } from "../SFProIcon"

export interface CloseIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Close icon using SF Pro font symbol (􀈎)
 *
 * This icon represents close/clear action in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <CloseIcon />
 * <CloseIcon size={16} weight="semibold" />
 * ```
 */
export const CloseIcon = React.forwardRef<HTMLSpanElement, CloseIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀈎" {...props} />
  }
)

CloseIcon.displayName = "CloseIcon"
